import { Component } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Platform } from '@ionic/angular';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  myCustomIcon = "/assets/img/rumbapp.png";
  constructor(private platform:Platform, private iab:InAppBrowser) {}

  downloadRumbapp(){
    //if(this.platform.is('android')){
      this.iab.create('https://play.google.com/store/apps/details?id=com.lyonincode.rumbapp&hl=es_419&gl=US');
    //}
  }

  goInstagram(){
    this.iab.create('https://www.instagram.com/loquehayfm');
  }
}
